module.exports = __webpack_public_path__ + "img/PayPal.d4f0c6ed.svg";